import styled          from 'styled-components'
import { motion }      from 'framer-motion'

export const PopupBox = ({children}) => {
  return <>
    <Motion  {...motionProps}>
      {children}
    </Motion>
  </>
}

export const Motion = styled(motion.div)`
  background-color: white;
  display:flex;
  flex-direction:column;
  border-radius: 10px;
  width:clamp(380px, 100% - 35px, 590px);
  position: fixed;
  top: 50%;
  left: 50%;
`

const dropIn = {
  hidden: { opacity: 1, transform:'scale(0)'},
  visible: { 
    opacity: 1,
    transform: 'translate(-50%, -50%) scale(1)',
    transition: { duration: 0.1, type: 'spring', damping: 35, stiffness: 500, },
  },
  exit: { opacity: 1 },
}

export const motionProps = {
  onClick: e => e.stopPropagation(),
  variants: dropIn,
  initial: 'hidden',
  animate: 'visible',
  exit: 'exit',
}